import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { t } from "i18next";

export function getEmployerDate(
  employer: components["schemas"]["EmploymentCheckFieldValue"]
) {
  return `${formatDate(employer.start_date, "MMM yyyy")} - ${
    employer.end_date ? formatDate(employer.end_date, "MMM yyyy") : t("Present")
  }`;
}

export function getAddressWithUnit(
  address: components["schemas"]["EmploymentCheckFieldValue"]["address"]
) {
  return address.unit ? `${address.unit}-${address.address}` : address.address;
}
